import { handleActions } from 'redux-actions';
import { GET_USERS_FILTER } from '../constants/get';

export const UsersFilter = handleActions({
    [GET_USERS_FILTER]:(state,action) => action.payload,
},null);